// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- THE CONTAINER --- */
.table-pagination-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  font-size: 12px;
  padding: 6px 15px;
  background-color: var(--bg-panel); /* Syncs with Dark/Light */
  color: var(--text-main);
}

.pagination-section, .pagination-nav {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-info {
  color: var(--text-dim); /* Replaces #666 */
}

/* --- THE SELECT (Cyber Glow) --- */
.pagination-select {
  background-color: #000 !important; /* Pure black for contrast */
  color: var(--accent-secondary, #00d4ff) !important; /* Cyan text */
  border: 1px solid var(--accent, #bc13fe) !important; /* Purple border */
  border-radius: 4px;
  padding: 2px 4px;
  outline: none;
  font-weight: bold;
  cursor: pointer;
}

/* --- THE BUTTONS --- */
.pagination-btn {
  background-color: #1a1a1a;
  color: var(--text-main);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 2px 10px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.2s ease;
}

.pagination-btn:hover:not(:disabled) {
  border-color: var(--accent);
  color: var(--accent);
  box-shadow: 0 0 8px rgba(188, 19, 254, 0.3);
}

.pagination-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  border-color: transparent;
}

.pagination-current {
  color: var(--accent);
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/TractumUI/components/TablePagination.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,iCAAiC,EAAE,0BAA0B;EAC7D,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB,EAAE,kBAAkB;AAC5C;;AAEA,oCAAoC;AACpC;EACE,iCAAiC,EAAE,4BAA4B;EAC/D,kDAAkD,EAAE,cAAc;EAClE,mDAAmD,EAAE,kBAAkB;EACvE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB","sourcesContent":["/* --- THE CONTAINER --- */\n.table-pagination-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 20px;\n  font-size: 12px;\n  padding: 6px 15px;\n  background-color: var(--bg-panel); /* Syncs with Dark/Light */\n  color: var(--text-main);\n}\n\n.pagination-section, .pagination-nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pagination-info {\n  color: var(--text-dim); /* Replaces #666 */\n}\n\n/* --- THE SELECT (Cyber Glow) --- */\n.pagination-select {\n  background-color: #000 !important; /* Pure black for contrast */\n  color: var(--accent-secondary, #00d4ff) !important; /* Cyan text */\n  border: 1px solid var(--accent, #bc13fe) !important; /* Purple border */\n  border-radius: 4px;\n  padding: 2px 4px;\n  outline: none;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n/* --- THE BUTTONS --- */\n.pagination-btn {\n  background-color: #1a1a1a;\n  color: var(--text-main);\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  padding: 2px 10px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: all 0.2s ease;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  border-color: var(--accent);\n  color: var(--accent);\n  box-shadow: 0 0 8px rgba(188, 19, 254, 0.3);\n}\n\n.pagination-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n  border-color: transparent;\n}\n\n.pagination-current {\n  color: var(--accent);\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
